import Vue from 'vue'
import Vuex from 'vuex'
import VuexEasyFirestore from 'vuex-easy-firestore'
import auth_actions from "@/store/actions/auth_actions"
import state from "@/store/state"
import getters from "@/store/getters"
import mutations from "@/store/mutations"
import createPersistedState from 'vuex-persistedstate'
import { firebase, initFirebase } from "@/firebase"
import firebaseModule from "@/firebaseModule"
import table_actions from "@/store/actions/table_actions";
import broadcast_actions from "@/store/actions/broadcast_actions";
import user_actions from "@/store/actions/user_actions";

Vue.use(Vuex)

const easyFirestore = VuexEasyFirestore(
    [firebaseModule],
    {
      logging: true,
      FirebaseDependency: firebase
    },
);

export default new Vuex.Store({
  plugins: [createPersistedState(), ],
  state,
  getters,
  mutations,
  actions: {
      ...auth_actions,
      ...table_actions,
      ...broadcast_actions,
      ...user_actions
  },
  modules: {
  }
})

// initFirebase
initFirebase()
.catch((error) => {
  console.log(error)
  // take user to a page stating an error occurred
  // (might be a connection error, or the app is open in another tab)
});
